import RowBankTransfer from './RowBankTransfer';

export default RowBankTransfer;
